/* ================================================== */
/* FLICKITY > Medias
/* ================================================== */

var carouselsMobile;

function flickityMedias() {
	var $carousels = $('.medias');

	if ($carousels.length) {
		$carousels.each(function(index, element){

			var total = $(this).data('total');

			var mainMedias = $(this).parent().hasClass("main__medias");

			if (total > 1) {
				// Init
				var $carousel = $(element).flickity({
					cellSelector        : '.medias__item',
					cellAlign           : ($('.child--news').length) ? 'left' : 'center',
					wrapAround          : false,
					contain             : true,
					freeScroll          : false,
					pageDots            : false,
					imagesLoaded        : true,
					groupCells 			: (!breakpointXs && mainMedias) ? 2 : 1,
					draggable           : ($('html').hasClass('no-touchevents')) ? false : true
				});

				// Move buttons outside of hidden overflow
				if ($('.child--news').length) {
					$('.medias').after($('.flickity-button'));
				}

				// Refresh on image load
				$(element).imagesLoaded().progress(function(instance, image) {
					$carousel.flickity('resize');
				});

				// Refresh on resize
				$(window).on('scroll resize orientationchange', function() {
					$carousel.flickity('resize');
				});

				// Load
				$carousel.addClass('loaded');
			}

		});
	}
}

$(document).ready(flickityMedias());

$(window).on('resize orientationchange', function() {
	flickityChangeSize();
});

function flickityChangeSize(){
	if ( breakpointXs !== carouselsMobile){
		carouselsMobile = breakpointXs;
		flickityMedias();
	}
}